import { numFormat, valToString } from '@utils/tool';
import { TabsProps } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { projectStatusMap } from '../../../components/ProjectFromComponents/data';
import { DataFlagEnum } from '../AnnouncementList/announcement';
import { useSectorMark } from '@hooks/useSectorMarkHook';

export const use_PROJECT_LIST_COLUMNS = () => {
  const sectorMark = useSectorMark();
  return [
    {
      title: '项目ID',
      dataIndex: 'noticeCode',
      key: 'noticeCode',
      width: 180
    },
    {
      title: '项目范围',
      dataIndex: 'dataFlag',
      key: 'dataFlag',
      render: (val: any) => {
        return val === DataFlagEnum.dealer ? '经销' : '直销';
      }
    },
    {
      title: '当前处理人',
      dataIndex: 'currentProcessorUserName',
      key: 'currentProcessorUserName',
      width: 100
    },
    {
      title: '项目状态',
      dataIndex: 'noticeStatusValue',
      key: 'noticeStatusValue'
    },
    {
      title: '开标时间',
      dataIndex: 'tenderOpenTime',
      key: 'tenderOpenTime'
    },
    {
      title: '信息标题',
      dataIndex: 'infoTitle',
      key: 'infoTitle',
      width: 200
    },
    {
      title: '项目名称',
      dataIndex: 'noticeName',
      key: 'noticeName',
      width: 200
    },
    {
      title: sectorMark,
      dataIndex: 'sectorTypeValue',
      key: 'sectorTypeValue'
    },
    {
      title: '客户单位',
      dataIndex: 'customerCompany',
      key: 'customerCompany'
    },
    {
      title: '客户单位类型',
      dataIndex: 'customerCompanyTypeName',
      key: 'customerCompanyTypeName',
      width: 120,
      render: (val: any, record: any) => {
        return record.customerCompanyTypeName
          ? `${record.customerCompanyTypeName}${
              record.customerCompanySecondTypeName ? '/' : ''
            } ${record.customerCompanySecondTypeName || ''}`
          : '';
      }
    },
    {
      title: '产品分类',
      dataIndex: 'productLineName',
      key: 'productLineName'
    },
    {
      title: '标的物',
      dataIndex: 'subjectMatterName',
      key: 'subjectMatterName'
    },
    {
      title: '产品线',
      dataIndex: 'projectProductLineKeyNameStr',
      key: 'projectProductLineKeyNameStr'
    },
    {
      title: '品牌',
      dataIndex: 'projectBrandValueStr',
      key: 'projectBrandValueStr'
    },
    {
      title: '型号',
      dataIndex: 'projectModelValueStr',
      key: 'projectModelValueStr'
    },
    {
      // 公告标的物总数量
      title: '台数',
      dataIndex: 'subjectMatterTotalNumber',
      key: 'subjectMatterTotalNumber'
    },
    {
      title: '标的物中标总价(万元)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      render: (val: any, record: any) => {
        const text = numFormat(val);
        return (
          !text || text + ' ' + valToString(record.totalAmountCurrencyValue)
        );
      }
    },
    {
      title: '项目是否要求国产',
      dataIndex: 'importTypeValue',
      key: 'importTypeValue',
      width: 130
    },
    {
      title: '省',
      dataIndex: 'provinceName',
      key: 'provinceName'
    },
    {
      title: '市',
      dataIndex: 'cityName',
      key: 'cityName'
    },
    {
      title: 'LER',
      dataIndex: 'lerStatus',
      key: 'lerStatus',
      render: (val) => {
        //  是否为大规模设备更新 0是 1否
        return (
          <div>
            {val === 1 ? <span>否</span> : val === 0 ? <span>是</span> : null}
          </div>
        );
      }
    },
    {
      title: 'OPPID',
      dataIndex: 'oppId',
      key: 'oppId'
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      key: 'publishTime'
    },
    {
      title: '最近修改时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 120
    }
    // {
    //   title: '行业',
    //   dataIndex: 'industryName',
    //   key: 'industryName'
    // },
    // {
    //   title: '应用方向',
    //   dataIndex: 'applicationDirectionName',
    //   key: 'applicationDirectionName',
    //   render: (val: any, record: any) => {
    //     const { applicationDirectionName, applicationDirectionSecondName } =
    //       record;
    //     return `${applicationDirectionName}${
    //       applicationDirectionSecondName && '/'
    //     }${applicationDirectionSecondName}`;
    //   }
    // },
    // {
    //   title: '标的物型号',
    //   dataIndex: 'subjectMatterModel',
    //   key: 'subjectMatterModel',
    //   width: 100
    // },
    // {
    //   title: '招标预算',
    //   dataIndex: 'tenderBudget',
    //   key: 'tenderBudget',
    //   render: (val: any, record: any) => {
    //     const text = numFormat(val);
    //     return (
    //       !text || text + ' ' + valToString(record.tenderBudgetCurrencyValue)
    //     );
    //   }
    // },
    // {
    //   title: '中标商',
    //   dataIndex: 'successfulCompany',
    //   key: 'successfulCompany'
    // },
    // {
    //   title: '标的物品牌',
    //   dataIndex: 'subjectMatterBrand',
    //   key: 'subjectMatterBrand',
    //   width: 120
    // },
    // {
    //   title: '客户单位联系人',
    //   dataIndex: 'tenderOrgContacts',
    //   key: 'tenderOrgContacts',
    //   width: 120
    // },
    // {
    //   title: '客户单位联系方式',
    //   dataIndex: 'tenderOrgContactsMobile',
    //   key: 'tenderOrgContactsMobile',
    //   width: 150
    // },
    // {
    //   title: '预计采购时间',
    //   dataIndex: 'estimatedPurchaseTime',
    //   key: 'estimatedPurchaseTime'
    // },
  ] as ColumnsType;
};

export const itemsBase: TabsProps['items'] = [
  {
    key: '',
    label: '全部项目'
  },
  {
    key: projectStatusMap.waittingForTender,
    label: '待招标'
  },
  {
    key: projectStatusMap.duringTender,
    label: '招标中'
  },
  {
    key: projectStatusMap.replenishOppid,
    label: '待补充OppID'
  },
  {
    key: projectStatusMap.endTender,
    label: '结束招标'
  },
  {
    key: projectStatusMap.deleted,
    label: '已删除'
  }
];
